import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { ReactComponent as LogoSvg } from '../../logo.svg';
import './styles.sass';
import i18n from '../../i18n';

export default function Component() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 800 });
  const [language, setLanguage] = useState(i18n.language); // Track current language

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleLanguage = () => {
    const newLanguage = language === 'he' ? 'en' : 'he';
    i18n.changeLanguage(newLanguage);
    setLanguage(newLanguage);
  };
  const aboutUrl = language === 'he' ? "https://alphabeta.co.il/" : "https://alphabeta.co.il/en/";


  return (
    <header className='header'>
      <div className='headerLeft'>
        <RouterLink to="/">
          <LogoSvg />
        </RouterLink>
      </div>
      {isMobile && (
        <button className='hamburgerButton' onClick={toggleMenu}>
          {isMenuOpen ? 'X' : '☰'}
        </button>
      )}
      {(isMobile && isMenuOpen) && (
        <div className='headerRight-mobile'>
          <nav className='linkList-mobile'>
            <a className='link-mobile' href={aboutUrl}
             target="_blank" rel="noopener noreferrer">{i18n.t("Header.about")}</a>
            <RouterLink to="/family/ai" className='link-mobile'>{i18n.t("Header.ai_indices")}</RouterLink>
            <RouterLink to="/family/bonds" className='link-mobile'>{i18n.t("Header.bonds")}</RouterLink>
            <RouterLink to="/family/stocks" className='link-mobile'>{i18n.t("Header.stocks")}</RouterLink>
            <button className='languageButton-mobile' onClick={toggleLanguage}>
              {language === 'he' ? 'EN' : 'HE'}
            </button>
          </nav>
        </div>
      )}
      {!isMobile && (
        <div className='headerRight'>
          <nav className='linkList'>
            <a className='link' href={aboutUrl}
             target="_blank" rel="noopener noreferrer">{i18n.t("Header.about")}</a>
            <RouterLink to="/family/ai" className='link'>{i18n.t("Header.ai_indices")}</RouterLink>
            <RouterLink to="/family/bonds" className='link'>{i18n.t("Header.bonds")}</RouterLink>
            <RouterLink to="/family/stocks" className='link'>{i18n.t("Header.stocks")}</RouterLink>
          </nav>
          <button className='languageButton' onClick={toggleLanguage}>
            {language === 'he' ? 'EN' : 'HE'}
          </button>
        </div>
      )}
    </header>
  );
}
